import React, { useContext, useEffect, useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import { NotifyTargetInnerInDTO, NotifyTargetOutDTO } from '@api/ringil-api.v2.tsx';
import MultipleValues from '@components/ringil3/HelperComponents/MultipleValues.tsx';
import { isNullOrUndefined } from '@utils/utils.tsx';
import { ApiContext } from '@api/api.tsx';
import NotifyDropdown from '@components/RingilComponents/NotifyDropdown.tsx';

interface ComponentProps {
  secured?: SecuredConfig;
  notifiedTargets: NotifyTargetInnerInDTO[];
  onChange: (notifyTargets: NotifyTargetInnerInDTO[]) => void;
  required?: boolean;
  readonly?: boolean;
}

const InternalInfoNotifyTag: React.FC<ComponentProps> = ({ secured, readonly, required, notifiedTargets, onChange }) => {

  const [internalValue, setInternalValue] = useState<NotifyTargetOutDTO[]>();
  const [tagValue, setTagValue] = useState<NotifyTargetOutDTO[]>();
  const { tr } = useTranslationLgs();

  const [notifyTargetsOptions, setNotifyTargetsOptions] = useState<NotifyTargetOutDTO[]>([]);
  const { listNotifyTargets } = useContext(ApiContext);

  useEffect(() => {
    listNotifyTargets(data => setNotifyTargetsOptions(data));
  }, []);

  useEffect(() => {
    setInternalValue(notifyTargetsOptions.filter(values => notifiedTargets?.some(t => t.id === values.id && t.notifyTargetType === values.notifyTargetType)))
    setTagValue(notifyTargetsOptions.filter(values => notifiedTargets?.some(t => t.id === values.id && t.notifyTargetType === values.notifyTargetType)))
  }, [notifyTargetsOptions, notifiedTargets]);

  const renderText = () => {
    if (isNullOrUndefined(tagValue) || tagValue.length === 0) {
      return null;
    }

    return <MultipleValues values={tagValue.map(t => t.name)}></MultipleValues>;
  };

  return (
    <>
      <ButtonTag secured={secured}
        label={tr('InternalInfoNotifyTag.notifikovat', 'Notifikovat')}
        required={required}
        readonly={readonly}
        value={renderText()}
        onSave={onSuccess => {
          onChange(internalValue);
          onSuccess();
        }}
        onClose={() => {
          setInternalValue(tagValue);
        }}
        autoClose
        hideButtons={false}
        dataTestId="internalInfo-notify"
      >
        <NotifyDropdown
          notifyTargetOptions={notifyTargetsOptions}
          values={notifyTargetsOptions.filter(values => internalValue?.some(t => t.id === values.id && t.notifyTargetType === values.notifyTargetType))}
          onSelect={values => {
            setInternalValue(values);
          }}
          dataTestIdBase="internalInfo-notify"
        />
      </ButtonTag>
    </>
  );
};

export default InternalInfoNotifyTag;
